import type { FloorDef } from '../types';
import { room, door, stairs } from '../dsl';

/**
 * 다락 — 낮고 어둡고 통로가 좁다. 3층 벽장 뒤 사다리로 올라오면 다락 입구(ladderroom)에 선다.
 * 서쪽 세로 통로(apass1)·남쪽 가로 통로(apass2)·동쪽 세로 통로(apass3)가 U자로 이어지고,
 * 그 끝(북동쪽)에 괴물의 둥지(lair)가 통로 하나로만 붙어 있다. 헌 짐 보관실(attic2)은 apass3에서 빗장 문으로만 들어간다.
 * 막다른 곳: 지붕 밑(eaves)·새장 방·물탱크 방·apass1 남쪽 끝·apass3 북/남쪽 끝.
 * Grid 96 x 48.
 */
export const ATTIC: FloorDef = {
  id: 'attic',
  w: 96,
  h: 48,
  rooms: [
    // 서쪽 — 창고들과 지붕 밑 틈
    room('eaves', '지붕 밑', 2, 4, 23, 3, 'empty', 'plank', 'plaster'),
    room('attic1', '다락 창고', 10, 8, 15, 12, 'attic', 'plank', 'panel'),
    room('trunkattic', '트렁크 다락', 10, 21, 15, 12, 'storage', 'plank', 'plaster'),
    room('apass1', '좁은 통로', 26, 8, 3, 33, 'passage', 'plank', 'panel'),

    // 가운데 — 입구와 물탱크
    room('birdroom', '새장 방', 30, 8, 14, 9, 'attic', 'plank', 'panel', { windows: 0.2 }),
    room('ladderroom', '다락 입구', 30, 22, 10, 11, 'attic', 'plank', 'panel'),
    room('apass2', '좁은 통로', 30, 34, 43, 3, 'passage', 'plank', 'plaster'),
    room('tank', '물탱크 방', 44, 25, 10, 8, 'tank', 'plank', 'plaster', {
      props: [{ kind: 'crateStack', x: 44, y: 31 }],
    }),

    // 동쪽 — 감옥 후보와 둥지
    room('attic2', '헌 짐 보관실', 64, 12, 9, 8, 'attic', 'plank', 'panel', { prison: true }),
    room('apass3', '좁은 통로', 74, 10, 3, 36, 'passage', 'plank', 'panel'),
    room('lair', '괴물의 둥지', 78, 10, 16, 14, 'lair', 'plank', 'plaster'),
  ],
  doors: [
    // 서쪽 창고 구역
    door('attic1', 'eaves', 'door', { at: 0.2 }),
    door('apass1', 'attic1', 'door', { at: 0.5 }),
    door('apass1', 'trunkattic', 'door', { at: 0.4 }),
    door('attic1', 'trunkattic', 'door', { at: 0.7 }),
    // 통로 ↔ 가운데 방들
    door('apass1', 'birdroom', 'door', { at: 0.5 }),
    door('apass1', 'ladderroom', 'door', { at: 0.5 }),
    door('ladderroom', 'apass2', 'door', { at: 0.5 }),
    door('apass2', 'tank', 'door', { at: 0.5 }),
    // 통로끼리
    door('apass1', 'apass2', 'open'),
    door('apass2', 'apass3', 'open'),
    // 동쪽 — 감옥(빗장)과 둥지(통로 하나뿐)
    door('apass3', 'attic2', 'bolt', { id: 'attic-bolt', label: '헌 짐 보관실 문', at: 0.5 }),
    door('apass3', 'lair', 'open', { at: 0.5 }),
  ],
  stairs: [
    stairs('attic_l', 'ladderroom', 34, 26, 'down', 'S', 'third', 'attic3', { kind: 'ladder' }),
  ],
};
